import React, { useState, useRef, useEffect } from "react";
import { useT } from "@/context/LanguageContext";
import { Globe, CaretDown, Check } from "@phosphor-icons/react";

export function LanguageSwitcher({ light = false }) {
  const { lang, setLang, languages } = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = languages.find((l) => l.code === lang) || languages[0];

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="language-switcher"
        aria-label="Change language"
        className={`flex items-center gap-1.5 rounded-md px-2.5 py-2 text-sm font-medium transition-colors hover:text-teal ${
          light ? "text-slate-700" : "text-white/90"
        }`}
      >
        <Globe size={18} weight="duotone" />
        <span>{current.short}</span>
        <CaretDown size={12} weight="bold" />
      </button>
      {open && (
        <div className="absolute right-0 z-50 mt-2 w-40 overflow-hidden rounded-lg border border-slate-200 bg-white py-1 shadow-xl" data-testid="language-menu">
          {languages.map((l) => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); }}
              data-testid={`language-option-${l.code}`}
              className={`flex w-full items-center justify-between px-4 py-2.5 text-sm transition-colors hover:bg-mist ${
                l.code === lang ? "font-semibold text-ink" : "text-slate-600"
              }`}
            >
              {l.label}
              {l.code === lang && <Check size={16} weight="bold" className="text-teal" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
